/**
 * DSGVO-Einwilligungstexte (Art. 7) — Version wird bei Änderungen hochgezählt.
 */
export const CONSENTS = {
  terms_privacy: {
    version: '1.0',
    label: 'AGB & Datenschutzerklärung',
    text: 'Ich habe die AGB und die Datenschutzerklärung gelesen und akzeptiere sie.',
  },
  share_insurance: {
    version: '1.2',
    label: 'Weitergabe an Versicherungsgesellschaften (Lead)',
    text: 'Ich willige ein, dass FuelX meine Anfrage-Daten (Fahrzeug-, Vertrags- und Kontaktdaten) als Lead an ausgewählte Versicherungsgesellschaften und lizenzierte Versicherungsvermittler weitergibt. Die Versicherung meldet sich direkt bei mir per Telefon oder E-Mail — jedoch nur, sofern sie mir einen günstigeren Preis anbieten kann; ein Anspruch darauf besteht nicht. Die Bearbeitung meiner Anfrage setzt eine bestellte FuelX Card und ein eingerichtetes Nutzerkonto voraus. Diese Einwilligung ist freiwillig und jederzeit im Dashboard widerrufbar (Art. 6 Abs. 1 lit. a DSGVO).',
  },
  share_bank: {
    version: '1.2',
    label: 'Weitergabe an Banken & Kreditinstitute (Lead)',
    text: 'Ich willige ein, dass FuelX meine Anfrage-Daten (Finanzierungs-, Fahrzeug- und Kontaktdaten) als Lead an Banken, Kreditinstitute und lizenzierte Darlehensvermittler weitergibt. Die Bank meldet sich direkt bei mir per Telefon oder E-Mail — jedoch nur, sofern sie mir eine günstigere Kondition anbieten kann; ein Anspruch darauf besteht nicht. Die Bearbeitung meiner Anfrage setzt eine bestellte FuelX Card und ein eingerichtetes Nutzerkonto voraus. Diese Einwilligung ist freiwillig und jederzeit im Dashboard widerrufbar (Art. 6 Abs. 1 lit. a DSGVO).',
  },
  share_dealer: {
    version: '1.0',
    label: 'Weitergabe an geprüfte Händler',
    text: 'Ich willige ein, dass FuelX meine Fahrzeug- und Kontaktdaten zur Erstellung von Ankaufsangeboten an geprüfte Händler und Ankäufer weitergibt. Diese Einwilligung ist freiwillig und jederzeit im Dashboard widerrufbar (Art. 6 Abs. 1 lit. a DSGVO).',
  },
  share_hotel_partner: {
    version: '1.0',
    label: 'Weitergabe an Buchungs-Dienstleister',
    text: 'Ich willige ein, dass FuelX meine Reise- und Kontaktdaten zur Reservierung an den jeweiligen Hotel-Buchungs-Dienstleister weitergibt. FuelX tritt dabei als Vermittler auf. Diese Einwilligung ist jederzeit im Dashboard widerrufbar (Art. 6 Abs. 1 lit. a DSGVO).',
  },
  share_service_partner: {
    version: '1.0',
    label: 'Weitergabe an Werkstätten',
    text: 'Ich willige ein, dass FuelX meine Fahrzeug- und Kontaktdaten zur Angebotserstellung und Terminvereinbarung an Werkstätten und Dienstleister weitergibt. FuelX tritt dabei als Vermittler auf. Diese Einwilligung ist jederzeit im Dashboard widerrufbar (Art. 6 Abs. 1 lit. a DSGVO).',
  },
  contact_processing: {
    version: '1.0',
    label: 'Verarbeitung der Kontaktanfrage',
    text: 'Ich willige ein, dass meine Angaben aus dem Kontaktformular zur Bearbeitung meiner Anfrage erhoben und verarbeitet werden. Die Daten werden nach abschließender Bearbeitung gelöscht (Art. 6 Abs. 1 lit. a DSGVO).',
  },
  newsletter: {
    version: '1.0',
    label: 'Newsletter-Einwilligung',
    text: 'Ich willige ein, den FuelX-Newsletter mit Angeboten und Produkt-Updates per E-Mail zu erhalten. Abmeldung jederzeit über den Link in jeder E-Mail möglich (Art. 6 Abs. 1 lit. a DSGVO).',
  },
};
